// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import {
  hideListing as hideVolop,
  unhideListing as unhideVolop
} from '../redux/main/actions/groupDashboard/listings';
import { pushFlashMessage } from '../redux/main/actions/flashMessages';

type OwnProps = {
  volopId: string,
  groupId: string,
  render: ({
    hideVolop: () => void,
    unhideVolop: () => void,
    submitting: boolean
  }) => React.Node
};

type Props = {
  ...$Exact<OwnProps>,
  hideVolop: Function,
  unhideVolop: Function,
  pushFlashMessage: Function
};

type State = {
  submitting: boolean
};

// $FlowFixMe: Flow's not seeing redux props as being injected.
class HideGroupVolopContainer extends React.PureComponent<Props, State> {
  state = {
    submitting: false
  };

  hideVolop = () => {
    this.setState({ submitting: true });
    return this.props
      .hideVolop({
        groupId: this.props.groupId,
        listingType: 'VOLOP',
        listingId: this.props.volopId
      })
      .then(() => {
        this.setState({ submitting: false });
        this.props.pushFlashMessage({
          type: 'LISTING_HIDDEN'
        });
      });
  };

  unhideVolop = () => {
    this.setState({ submitting: true });
    return this.props
      .unhideVolop({
        groupId: this.props.groupId,
        listingType: 'VOLOP',
        listingId: this.props.volopId
      })
      .then(() => {
        this.setState({ submitting: false });
        this.props.pushFlashMessage({
          type: 'LISTING_UNHIDDEN'
        });
      });
  };

  render() {
    return this.props.render({
      hideVolop: this.hideVolop,
      unhideVolop: this.unhideVolop,
      submitting: this.state.submitting
    });
  }
}

export default connect<Props, OwnProps, _, _, _, _>(
  null,
  { hideVolop, unhideVolop, pushFlashMessage }
)(HideGroupVolopContainer);
